import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import { GUID } from "app/brightserve/brightserve.module";
import { Doctor, User } from "app/shared/shared.module";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()
export class DoctorService {

    constructor(private http: HttpClient) { }

    GetCurrentDoctorDetails(): Observable<Doctor> {
        return this.http.get("/doctor/details").map((res: any) => new Doctor(res.Doctor) || {});
    };

    GetDoctorDetailsById(Id: GUID): Observable<Doctor> {
        return this.http.get("/doctor/" + Id + "/details").map((res: any) => new Doctor(res.Doctor) || {});
    };

    ChangeDetails(ChangeDetails): Observable<Doctor> {
        var data = {
            Doctor: {
                Id: ChangeDetails.Id,
                Email: ChangeDetails.Email,
                PhoneNumber: ChangeDetails.PhoneNumber,
                Name: ChangeDetails.Name,
                Username: ChangeDetails.Username,
            }
        };
        return this.http.post("/doctor/changedetails", data).map((res: any) => new Doctor(res.Doctor) || {});
    }

    ChangePassword(PasswordChange): Observable<Doctor> {
        return this.http.post("/doctor/changepassword", PasswordChange).map((res: any) => new Doctor(res.Doctor) || {});
    }
}



// WEBPACK FOOTER //
// ./src/app/doctor/doctor.service.ts